import { toast } from "react-toastify";
import { showToast } from "./toastUtils";

export const handleHttpError = (error: any) => {
  const status = error?.response?.status || 500;
  const message = error?.response?.data?.message || "Something went wrong!";

  switch (status) {
    case 400:
      showToast.warning(message);
      break;
    case 401:
      showToast.warning("Unauthorized. Please login.");
      break;
    case 403:
      showToast.error("Forbidden: " + message);
      break;
    case 404:
      showToast.info("Resource not found.");
      break;
    case 500:
      showToast.warning("Server error! Please try again later.");
      break;
    default:
      showToast.warning(message);
  }
};

export const handleCustomError = (response: any) => {
  if (!response?.data) {
    console.warn("ReponseHandler skipped: Invalid response format.");
    return;
  }

  // console.log("✅ Response in ReponseHandler:", response.data);

  const tostStyle: {} = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    closeButton: false,
  };

  const status = response?.data?.statusCode;
  const message = response?.data?.message || "Something went wrong!";

  switch (status) {
    case 201:
      showToast.success(message);
      break;
    case 400:
      showToast.warning(message);
      break;
    case 401:
      showToast.warning("Unauthorized. Please login.");
      break;
    case 403:
      showToast.error("Forbidden: " + message);
      break;
    case 404:
      showToast.info("Resource not found.");
      break;
    case 409:
      showToast.warning(message);
      break;
    case 500:
      showToast.warning("Server error! Please try again later.");
      break;
    default:
      console.log("✅ Moving ahead, no error handling needed.");
  }
};
